import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import closeImg from '../../../assets/close.svg';
// import successImg from '../../../assets/success.svg';
import { maskPlate } from '../../../utils/masks';
import MaskedInput from 'react-text-mask';
import { API_URL } from '../../../services/api';
import { Container, InputGrid } from './styles';

export function VehicleModal({ isOpen, onRequestClose, vehicle }) {
  const [licensePlate, setLicensePlate] = useState('');
  const [alias, setAlias] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState('');
  // const [requestSuccess, setRequestSuccess] = useState('');

  // Modo edição: precisamos do id do veículo antigo para excluí-lo depois
  const isEditing = Boolean(vehicle?.id);

  useEffect(() => {
    if (vehicle?.id) {
      setLicensePlate(vehicle?.licensePlate||'')
      setAlias(vehicle?.alias||'')
      setType(vehicle?.type||'')
    } else {
      setLicensePlate('');
      setAlias('');
      setType('');
    }
  },[vehicle])

  const handleNewVehicle = async (e) => {
    e.preventDefault();
    setLoading(true);

    const body = {
      licensePlate: licensePlate.replace('-', ''),
      alias,
      type: type.toLowerCase(),
    };

    const res = await fetch(`${API_URL}/vehicles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    });

    const response = await res.json();

    // console.log(body);
    // console.log(response);

    // Falhou o cadastro: aborta sem excluir nada e mantém o modal aberto
    // para o operador corrigir os dados.
    if (!res.ok) {
      toast.error(response.message);
      setLoading(false);
      return;
    }

    if (!isEditing) {
      toast.success(response.message);
      setLicensePlate('');
      setAlias('');
      setType('');
      setLoading(false);
      return;
    }

    // Não existe endpoint de atualização de veículo: a edição é simulada
    // cadastrando o novo e só então excluindo o antigo.
    const resDelete = await fetch(`${API_URL}/vehicles/${vehicle.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem('token'),
      },
    });

    const responseDelete = await resDelete.json().catch(() => ({}));

    if (!resDelete.ok) {
      toast.error(
        `O veículo ${body.licensePlate} foi cadastrado, mas não foi possível excluir o veículo anterior (${vehicle.licensePlate}), que continua na sua lista. ${responseDelete?.message || ''}`
      );
      setLoading(false);
      return;
    }

    toast.success('Veículo atualizado com sucesso!');
    setLoading(false);
    onRequestClose();
  };

  // if (requestSuccess !== '')
  //   return (
  //     <Modal
  //       isOpen={isOpen}
  //       onRequestClose={onRequestClose}
  //       overlayClassName="react-modal-overlay"
  //       className="react-modal-content"
  //     >
  //       <button
  //         type="button"
  //         onClick={onRequestClose}
  //         className="react-modal-close"
  //       >
  //         <img src={closeImg} alt="Fechar modal" />
  //       </button>

  //       <Result className="animeLeft">
  //         <h2>{requestSuccess}</h2>
  //         <img src={successImg} alt="Sucesso" onClick={onRequestClose} />
  //       </Result>
  //     </Modal>
  //   );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <ToastContainer />

      <button
        type="button"
        onClick={onRequestClose}
        className="react-modal-close"
      >
        <img src={closeImg} alt="Close modal" />
      </button>

      <Container onSubmit={handleNewVehicle}>
        <h2>{isEditing ? 'Editar Veículo' : 'Cadastrar Veículo'}</h2>

        <InputGrid>
          <MaskedInput
            mask={maskPlate}
            placeholder="Placa"
            guide={false}
            type="text"
            value={licensePlate.toUpperCase()}
            onChange={(event) => setLicensePlate(event.target.value)}
            required
          />

          <input
            placeholder="Apelido deste veículo"
            type="text"
            maxLength={15}
            value={alias}
            onChange={(event) => setAlias(event.target.value.toUpperCase())}
          />
        </InputGrid>

        <select
          type="text"
          value={type}
          onChange={(event) => setType(event.target.value)}
          required
        >
          <option value="" disabled defaultValue hidden>
            Tipo de veículo
          </option>
          <option value="Carro">Carro</option>
          <option value="Caminhão">Caminhão</option>
          <option value="Motocicleta">Motocicleta</option>
          <option value="Ônibus">Ônibus</option>
        </select>

        {loading ? (
          <button type="submit" disabled>
            Salvando
          </button>
        ) : (
          <button type="submit">{isEditing ? 'Salvar alterações' : 'Salvar'}</button>
        )}
      </Container>
    </Modal>
  );
}
